export default {
  props: {
    showLabel: {
      type: Boolean,
      default: true,
      required: false
    },
    model: {
      type: Object,
      // aby móc używać bez podawania modelu
      default: () => ({
        $schema: {
          title: ''
        }
      }),
      required: false
    },
    boldLabel: {
      type: Boolean,
      default: false,
      required: false
    },
    labelFor: {
      type: String,
      default: undefined,
      required: false
    },
    title: {
      type: String,
      default: undefined,
      required: false
    },
    description: {
      type: Object,
      default: () => ({
        value: '',
        tooltip: false,
        htmlContent: false,
        newLine: true
      }),
      required: false
    },
    nextNumber: {
      type: Object,
      default: null,
      required: false
    },
    aria: {
      type: String,
      default: ''
    }
  },
  computed: {
    getTitle: {
      get() {
        if (this.title === undefined || this.title === null) {
          return this.model.$schema.title;
        }
        return this.title;
      }
    },
    activeAria() {
      if (!this.showLabel) return this.aria;
      return undefined;
    }
  }
};
